import React from 'react';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FieldCaption, FieldTooltip, RadioGroupRoot, Root } from '../styles';
var RadioInput = function (props) {
    var id = props.id, value = props.value, values = props.values, caption = props.caption, tooltip = props.tooltip, _a = props.size, size = _a === void 0 ? 'small' : _a, _b = props.big, big = _b === void 0 ? false : _b, _c = props.direction, direction = _c === void 0 ? 'column' : _c, onChange = props.onChange;
    var onValueChange = function (val) { return function () {
        if (onChange) {
            onChange(val);
        }
    }; };
    return (React.createElement(Root, { size: size, style: { margin: '0 5px' } },
        React.createElement(FieldCaption, null, caption),
        React.createElement(RadioGroupRoot, { column: direction === 'column' }, values === null || values === void 0 ? void 0 : values.map(function (item, idx) { return (React.createElement(FormControlLabel, { key: idx.toString(), value: item.value, control: React.createElement(Radio, { color: "primary", size: big ? 'medium' : 'small' }), label: item.text, name: id, checked: item.value === value, onChange: onValueChange(item.value) })); })),
        React.createElement(FieldTooltip, null, tooltip)));
};
RadioInput.defaultProps = {
    size: 'small',
    big: false,
    direction: 'column',
    onChange: undefined,
};
export default RadioInput;
//# sourceMappingURL=RadioInput.js.map